import dayjs from "dayjs";
import writeXlsxFile, { SheetData } from "write-excel-file";

interface IColDefs {
  title: string;
  dataIndex: string;
  excelWidth?: number;
  excelValueFormatter?: (val: any) => string;
}

export const writeExcel = async (
  dataArray: object[],
  colDefs: IColDefs[],
  fileNamePrefix: string,
  headerTitle?: string
) => {
  const columns = colDefs.map((col) => ({
    column: col.title,
    type: String,
    width: col.excelWidth || 80,
  }));

  const headerRow = [
    [
      {
        value: headerTitle,
        fontWeight: "bold",
        align: "left",
        span: colDefs.length,
      },
    ],
  ] as SheetData;

  const columnHeaders = [
    colDefs.map((col) => ({
      value: col.title,
      fontWeight: "bold",
    })),
  ];

  const dataRows = dataArray.map((record: any) =>
    colDefs.map((col) => ({
      value: col.excelValueFormatter
        ? col.excelValueFormatter(record[col.dataIndex])
        : `${record[col.dataIndex]}` || "",
    }))
  );

  const data: SheetData = headerTitle
    ? [...headerRow, ...columnHeaders, ...dataRows]
    : [...columnHeaders, ...dataRows];

  try {
    await writeXlsxFile(data, {
      columns,
      fileName: `${fileNamePrefix}_${dayjs().format("DD.MM.YYYY")}.xlsx`,
    });
  } catch (err) {
    console.error(err);
  }
};
